<template>
    <div class="privacy-box" style="display: flex;flex-direction: column;align-items: center;margin-bottom: 2rem;">
        <div style="margin-top: 2.25rem;font-size: 2rem;line-height: 2rem;font-weight: bold;color: #B62D2E;">{{ $t('other.privacy') }}</div>
        <div style="display: flex;margin-top:0.5rem;margin-bottom:5rem;">
            <span style="width: 1rem;height: 1rem;background:#B62D2E;border-radius: 50%;margin:0 0.5rem;"></span>
            <span style="width: 1rem;height: 1rem;background:#DE5934;border-radius: 50%;margin:0 0.5rem;"></span>
            <span style="width: 1rem;height: 1rem;background:#F1AA55;border-radius: 50%;margin:0 0.5rem;"></span>
        </div>
        <div class="col-xs-22 col-sm-13">
          <p><strong>隱私政策</strong></p><p>數學思維教育有限公司教育服務有限公司注重保護訪客私隱。本私隱條款解釋了下列情況下的資料搜集和使用情況。</p><p>本條款適用於數學思維教育有限公司網站的所有相關服務。</p><p>我們的營業地點為九龍荔枝角長沙灣道918號維特健靈中心15樓。</p><p>我們保留不時更新本私隱條款的權利。</p><p><strong>個人資訊的搜集和使用</strong></p><p>本公司認為個人身份識別資訊，例如您的姓名和電子郵件或電話號碼，是私人保密的。</p><p><br></p><p>您可以對本網站進行普通訪問，不提供任何個人身份資訊。只有個別必要情況下，您需要主動提供個人資訊。例如當您需要在線諮詢、訂閱電子報或者預約項目課程時。</p><p><strong>透露資訊給第三方</strong></p><p>未經當事人允許，本公司不會將您的個人資訊透露給第三方。以下情況除外：</p><p>·&nbsp;滿足法律的明文規定。</p><p>·&nbsp;數學思維教育有限公司網站其他用戶的權利及安全。</p><p>本網站搜集的資訊亦不會以買賣、分享或租借等任何形式透露給任何其他公司或組織，未經當事人同意，也不會在本公司其他部門運用。</p><p><strong>其他鏈接</strong></p><p>對於本網站中包含的其他網站連接中的內容，數學思維教育有限公司不負法律責任。</p><p><strong>免責聲明</strong></p><p>數學思維教育有限公司網站所提供的資訊僅供參考。</p><p>數學思維教育有限公司將盡力保證本網站資訊的正確性，最終解釋權歸本公司所有。</p><p>對於錯誤使用、無法使用本網站資訊或任何站內操作所造成的損失，本公司不負法律責任。</p><p><strong>Cookies, 域名和IP地址</strong></p><p>閣下到訪本網站時，網站會作記錄，以分析網站的訪客人數和一般使用狀況。其中部分資料將透過「Cookies」方式收集。</p><p><br></p><p>「Cookies」即載有小量資料的檔案，自動儲存於訪客本身電腦所安裝的互聯網瀏覽器，可供本網站日後檢索。</p><p>「Cookies」讓本網站知道用戶對網頁的喜好，以便本網站日後為其用戶營造更理想的網上體驗。</p><p>「Cookies」收集的是不記名的集體統計資料，並不包括姓名、地址、及電話、電郵地址等個人聯絡資料。</p><p><br></p><p>目前常見的瀏覽器版本均預設啟動「Cookies」的功能。如閣下想禁用「Cookies」，可更改瀏覽器的設定，但更改後可能防礙進入本網站的某些部分。</p><p>當閣下登錄到本網站，本網站將通過其網絡服務器，自動收集閣下的域名和 IP 地址以作核實及供本網站就訪客流量統計和數據分析用途。</p>
        </div>
      <br><br><br><br><br><br>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            content:""
        };
    },
    watch: {

    },
    created() {
        
    },
    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
/*.privacy-box{
    margin:0 22vw;
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .privacy-box{
        margin:0 1.25rem 2rem;
    }
}*/
</style>